import { Either, Left, Right } from "../../core/types/Either";
import { FlexPackageRepository } from "../../domain/repository/FlexPackageRepository";
import { FlexPackageRemoteDataSource } from "../dataSource/FlexPackageRemoteDataSource";
import { FlexProduct } from "../../domain/entity/FlexPackage";

export class FlexPackageRepositoryImpl extends FlexPackageRepository {
  remoteDataSource: FlexPackageRemoteDataSource;

  constructor(remoteDataSource: FlexPackageRemoteDataSource) {
    super();
    this.remoteDataSource = remoteDataSource;
  }

  async getProducts(
    appPid?: number,
    packageId?: string
  ): Promise<Either<Error, FlexProduct[]>> {
    try {
      return Right(await this.remoteDataSource.getProducts(appPid, packageId));
    } catch (e) {
      return Left(e);
    }
  }
}
